import { render } from "./bottomMenu.vue?vue&type=template&id=5327c980&scoped=true"
import script from "./bottomMenu.vue?vue&type=script&lang=js"
export * from "./bottomMenu.vue?vue&type=script&lang=js"

import "./bottomMenu.vue?vue&type=style&index=0&id=5327c980&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5327c980"]])

export default __exports__